<template>
    <div>
        <div v-if="!app.isSpinnerVisible">
            <!-- ------------------------------------------------------ -->
            <!-- ELEMENTS AMB POSICIO STICKY -> IMATGE I BUTONS DESKTOP -->
            <!-- ------------------------------------------------------ -->
            <div class="s2_right sticky_web">
                <!--    DESKTOP   -->
                <div v-if="!isMobile">
                    <img
                        v-if="
                            app.currentConfiguration.familyImage &&
                            app.currentConfiguration.familyImage.length > 0
                        "
                        v-lazy="app.currentConfiguration.familyImage[0].url"
                        alt
                        class="s2_image"
                        style="
                            width: 100%;
                            max-width: 400px;
                            margin: 0px;
                            border: 0px solid black;
                            margin: auto;
                        "
                    />
                </div>

                <!--     MOBIL    -->
                <div
                    v-else
                    class="d-flex justify-content-center align-items-center"
                >
                    <div class="image-cropper shadow">
                        <img
                            height="120"
                            width="120"
                            :src="app.currentConfiguration.familyImage[0].url"
                        />
                    </div>
                </div>
            </div>

            <!-- ------------------------ -->
            <!-- BUTONS NAVEGACIO DESKTOP -->
            <!-- ------------------------ -->
            <navigation/>

            <!-- ---------------------------- -->
            <!-- SELECCIO PARAMETRES DESKTOP  -->
            <!-- ---------------------------- -->
            <div v-if="!isMobile" class="s2_left">
                <div
                    v-for="(parameter, key, index) in app.currentConfiguration
                        .familyParameters"
                    :key="parameter.attribute.id"
                >
                    <div class="card mb-3" v-if="parameter.parameter_definition.visibility">
                        <div
                            :id="'heading' + parameter.attribute.id"
                            class="
                                card-header
                                d-flex
                                flex-row
                                align-items-center
                                justify-content-between
                            "
                            :class="{
                                    'text-danger': !parameter.value && app.currentConfiguration.validation.valid == false
                                }"
                        >
                            <!-- icono check -->
                            <div class="text-left">
                                <span v-if="parameter.value.name">
                                    <i
                                        class="
                                            size_check_desktop
                                            fa-lg
                                            far
                                            fa-check-circle
                                            ml-1
                                            mr-3
                                        "
                                        style="color: black"
                                    ></i>
                                </span>
                            </div>

                            <!-- titel -->
                            <div class="text-left">
                                <strong class="text-left">{{
                                    parameter.attribute.name
                                }}</strong>
                                : {{ parameter.valueString }}
                            </div>

                            <!-- 3rd element to position centered titel-->
                            <div></div>
                        </div>
                        <div class="card-body">
                            <div :id="'collapse' + parameter.attribute.id">
                                <div class="m-2 p-2">
                                    <editParameterValueComponent
                                        :prop_title_show="false"
                                        :labelOverInput="true"
                                        :parameter="parameter"
                                        :value.sync="parameter.value"
                                        @update:value="refreshParameters"
                                    ></editParameterValueComponent>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ---------------------------- -->
            <!-- SELECCIO PARAMETRES MOBIL  -->
            <!-- ---------------------------- -->
            <div
                v-else
                class="accordion align-self-stretch mb-4 s2_left_mobile"
                id="accordion_p2"
            >
                <div
                    v-for="(parameter, key, index) in app.currentConfiguration
                        .familyParameters"
                    :key="parameter.attribute.id"
                    class="card"
                >
                    <div
                        class="card-header"
                        :id="'heading' + parameter.attribute.id"
                        style="cursor: pointer"
                        data-toggle="collapse"
                        :data-target="'#collapse' + parameter.attribute.id"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                    >
                        <div class="d-flex justify-content-between">
                            <div class="text-left"
                                :class="{
                                    'font-weight-bold': parameter.attribute.id === 'sol_constructiva'
                                }">
                                <!-- icono check -->
                                <span v-if="parameter.value.name">
                                    <i
                                        class="
                                            size_check_mobile
                                            far
                                            fa-check-circle
                                            ml-2
                                            mr-2
                                        "
                                        style="color: black"
                                    ></i>
                                </span>

                                <strong>{{ parameter.attribute.name }}</strong
                                >: {{ parameter.value.name }}
                            </div>
                        </div>
                    </div>

                    <!-- ALWAYS EXPANDED IN MOBILE -->
                    <div
                        :id="'collapse' + parameter.attribute.id"
                        class="show"
                        aria-labelledby="headingOne"
                        data-parent="#accordion_p2"
                    >
                        <div class="card-body">
                            <editParameterValueComponent
                                :prop_title_show="false"
                                :labelOverInput="true"
                                :parameter="parameter"
                                :value.sync="parameter.value"
                                @update:value="refreshParameters"
                            ></editParameterValueComponent>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ----------------------------------- -->
            <!--         NAVEGACIO                   -->
            <!-- ----------------------------------- -->
            <div :class="!isMobile ? 's2_left' : ''">
                <navigation/>
            </div>
        </div>
    </div>
</template>


<style scoped lang="scss">
.btn_bottom_width {
    width: 220px;
}

.btn_text_color_grey {
    color: #6c757d;
}

#accordion_p2 {
    position: relative;
    margin-top: 10px;
}

//round image
.image-cropper {
    width: 120px;
    height: 120px;
    position: relative;
    overflow: hidden;
    border-radius: 50%;
    border: 1px solid #dcdcdc;
}

.titel {
    background-color: rgb(228, 228, 228);
    padding: 8px;
    border-style: solid;
    border-width: 1px;
    border-color: rgb(163, 163, 163);
    border-radius: 50px;
}
.size_check_desktop {
    font-size: 1.75em;
}

.size_check_mobile {
    font-size: 1.3em;
}

.s2_image {
    border-radius: 10px;
}

.sticky_web {
    position: sticky;
    top: 130px;
    height: 127px;
}

.sticky_buttons {
    position: sticky;
    top: 120px;
    z-index: 10;
    height: 70px;
    background-color: white;
}

@media (max-height: 825px) {
    .s2_image {
        max-width: 250px;
    }
}

@media (max-height: 720px) {
    .s2_image {
        max-width: 225px;
    }
}

@media (max-height: 700px) {
    .s2_image {
        max-width: 200px;
    }
}

@media (max-height: 670px) {
    .s2_image {
        max-width: 175px;
    }
}

@media (max-height: 400px) {
    .s2_image {
        max-width: 200px;
    }
}

.s2_left {
    width: 54%;
    margin-left: 1%;
}

.s2_right {
    width: 39%;
    margin-right: 1%;
    margin-left: 5%;
    float: right;
    background-color: white;
}

@media (max-width: 750px) {
    .s2_left_mobile {
        padding-right: 0%;
        padding-left: 0%;
        width: 100%;
        position: relative;
        top: 0px;
        margin-left: 0%;
    }

    .s2_right {
        z-index: 10;
        width: 100%;
        padding-right: 0%;
        padding-top: 2px;
        margin-right: 0%;
        margin-left: 0%;
        float: none;
        background-color: white;
    }

    .s2_image {
        max-width: 150px;
        max-height: 150px;
    }

    .sticky_web {
        position: sticky;
        top: 0;
    }
}
</style>


<script>
import { app } from "../../application.js";
import jQuery from "jquery";
import editParameterValueComponent from "../editParameterValue.vue";
import navigation from "../common/navigation.vue";

export default {
    name: "genericConfiguratorComponent",
    data() {
        return {
            app: app,
            beforeRouteLeaveResolved: false,
            window_width: window.innerWidth,
            buttonLoading: false,
            window: { width: 0, height: 0 },
        };
    },
    components: {
        navigation,
        editParameterValueComponent
    },
    methods: {
        updateWindowSize() {
            this.window_width = window.innerWidth;
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        navigate_p1: async function () {
            try {
                this.buttonLoading = true;
                app.navigateToStageAsync("1");
                this.buttonLoading = false;

            } catch (error) {
                this.buttonLoading = false;
            }
        },
        selectedAllFamilyParams: function () {
            let all_famParams_are_selected = true;

            Object.entries(
                this.app.currentConfiguration.familyParameters
            ).forEach(([key, value]) => {
                if (value.valueString == "") {
                    all_famParams_are_selected = false;
                }
            });

            return all_famParams_are_selected;
        },
        clean: function (selected_attribute_name) {
            var familyParams = this.app.currentConfiguration.familyParameters;
            Object.values(familyParams).map((parameter) => {
                if (parameter.attribute.name == selected_attribute_name) {
                    if (parameter.value.constructor.name == "Array") {
                        parameter.value = [];
                    } else {
                        parameter.value = "";
                    }
                }
            });

            this.$emit("clearCheckboxes");
            this.refreshParameters();
        },
        cleanAllSelectors: function () {
            //loop through familyParameters values resetting all selected values in currentConfiguration.familyParameters
            let famParams = this.app.currentConfiguration.familyParameters;
            Object.values(famParams).map((item) => {
                if (item.value.constructor.name == "Array") {
                    item.value = [];
                } else {
                    item.value = "";
                }
            });
            this.$emit("clearCheckboxes");
            //send changes done to server
            this.refreshParameters();
        },

        refreshParameters: async function () {
            await this.app.asyncProcess(false);
        },

        tryNavigateToMainElement: function () {
            try {
                this.buttonLoading = true;
                this.app.navigateToNextStage();
                this.buttonLoading = false;
            } catch (error) {
                this.buttonLoading = false;
            }
        },
        updateWindowSize() {
            this.window_width = window.innerWidth;
        },
    },

    //nomes per si tira endarrera amb el navegador
    beforeRouteLeave(to, from, next) {
        if (to.name !== "3" && to.name !== "2") {
            let self = this;

            //Here the message could be stored in the app depending on the language
            let infoModal = {
                modalToShow: "warnPageLeaveModal",
                title: self.app.translate(
                    "popup_warn_changes_will_be_lost_titel"
                ),
                message: self.app.translate(
                    "popup_warn_changes_will_be_lost_message"
                ),
                html_message: "",
                showConfirmationButton: true,
                showCancelButton: true,
                textConfirmationButton: self.app.translate(
                    "default_text_acceptbutton"
                ),
                textCancelButton: self.app.translate(
                    "default_text_cancelbutton"
                ),
            };

            self.app
                .showModal(infoModal)
                .then(({ userAction, paramResult }) => {
                    if (userAction === "modal_rejected") {
                        next(false);
                        //do nothing
                    } else if (userAction === "modal_confirmed") {
                        next(true);
                    }
                });
        } else if (
            to.name === "3" &&
            this.app.currentConfiguration.stage === "3"
        ) {
            next(true);
        }
    },

    created() {
        //get window size
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },

    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },

    computed: {
        isMobile: function () {
            let a = this.window.width < 750;
            return a;
        },
    },
    beforeDestroy() { },
};
</script>
